import React from "react";
import { cva, type VariantProps } from "cva";

const buttonVariants = cva(
    "inline-flex items-center justify-center rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:opacity-50 disabled:pointer-events-none ring-offset-background border-none space-x-2",
    {
        variants: {
            variant: {
                default: "bg-[#7556FA] text-white hover:bg-[#7556FA]/90",
            },
            size: {
                sm: "text-xs",
                md: "px-4 py-2 text-md",
                lg: "px-8 py-3 text-[16px]",
            }
        },
        defaultVariants: {
            variant: "default",
            size: "md"
        }
    }
);

export default function UIButton({
    className,
    size,
    variant,
    ...props
                                 }: React.ComponentProps<"button"> & VariantProps<typeof buttonVariants>) {
    return (
        <button
            className={buttonVariants({ variant, size, className })}
            {...props}
        />
    );

}
